import {
  Autocomplete,
  AutocompleteItem,
  AutocompleteProps,
} from "@heroui/react";
import { useAppSelector } from "@/hooks/useAppSelector.ts";
import { City } from "@/api/locations";

export function CityHandbook(props: AutocompleteProps<City>) {
  const items = useAppSelector((state) => state.handbooks.cities);

  return (
    <Autocomplete
      defaultItems={items}
      label="Город"
      placeholder="Выберите город"
      variant="bordered"
      isRequired
      {...props}
    >
      {(item) => (
        <AutocompleteItem key={String(item.name)}>
          {item.display_name}
        </AutocompleteItem>
      )}
    </Autocomplete>
  );
}
